var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-cnt" },
    [
      _c("div", { staticClass: "ex-single" }, [
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.no")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(_vm._s(_vm.voucher.voucher_number))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.middle_classification")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row-cnt text-orange-sub font500 d-flex align-items-center"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.voucher.voucher_type_name) +
                  "\n                "
              ),
              _vm.voucher.has_file
                ? _c("i", {
                    staticClass: "icon-picture ml-4",
                    on: {
                      click: function($event) {
                        return _vm.showPdf()
                      }
                    }
                  })
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.transaction_date")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(
              _vm._s(
                _vm.dateUtils.formatDateYYYYMMDD(_vm.voucher.transaction_date)
              ) +
                "(" +
                _vm._s(_vm.dateUtils.getDay(_vm.voucher.transaction_date)) +
                ")"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.use")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(_vm._s(_vm.voucher.use))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.service")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(_vm._s(_vm.utils.getVoucherService(_vm.voucher.service)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.account_name")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(_vm._s(_vm.voucher.account_name))
          ])
        ]),
        _vm._v(" "),
        _vm.utils.isEmptyObj(_vm.tourInfo) ||
        _vm.tourInfo.tour_type == _vm.constants.TourType.international.id
          ? _c("div", { staticClass: "block-row" }, [
              _c("label", { staticClass: "row-lb font500" }, [
                _vm._v(_vm._s(_vm.$t("voucher.general.city")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-cnt" }, [
                _vm._v(_vm._s(_vm.voucher.city))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.personal")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.voucher.personal) +
                "\n                "
            ),
            _vm.voucher.personal
              ? _c("span", [_vm._v(_vm._s(_vm.$t("tour.person")))])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.unit_price")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(
              _vm._s(
                _vm.utils.formatPrice(
                  _vm.voucher.unit_price,
                  _vm.voucher.currency_id
                )
              ) +
                _vm._s(
                  _vm.voucher.unit_price
                    ? _vm.utils.getCurrencyName(_vm.voucher.currency_id)
                    : ""
                )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.amount")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(
              _vm._s(
                _vm.utils.formatPrice(
                  _vm.voucher.total_amount,
                  _vm.voucher.currency_id
                )
              ) + _vm._s(_vm.utils.getCurrencyName(_vm.voucher.currency_id))
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.category")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row-cnt text-orange font500 d-flex align-items-center"
            },
            [_vm._v(_vm._s(_vm.utils.getInOutType(_vm.voucher.type)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.tax_rate")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row-cnt text-orange font500 d-flex align-items-center"
            },
            [_vm._v(_vm._s(_vm.utils.getTaxRate(_vm.voucher.tax_rate)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.tax_free")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row-cnt text-orange font500 d-flex align-items-center"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.utils.getTaxExempt(_vm.voucher.tax_exempt)) +
                  "\n            "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.voucher.tax_rate == 3
          ? _c(
              "div",
              _vm._l(_vm.voucher.other_tax, function(otherTax) {
                return _c(
                  "div",
                  { key: otherTax.id, staticClass: "block-row" },
                  [
                    _c("label", { staticClass: "row-lb font500" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt w-100" }, [
                      _c("div", { staticClass: "ex-sub-block" }, [
                        _c("div", { staticClass: "block-row" }, [
                          _c("div", { staticClass: "d-flex fs-15 w-100" }, [
                            _c(
                              "div",
                              {
                                staticClass: "w-re",
                                staticStyle: { "word-break": "break-all" }
                              },
                              [_vm._v(_vm._s(otherTax.description))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "w-65 text-right",
                                staticStyle: { "word-break": "break-all" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.utils.formatPrice(
                                      otherTax.price,
                                      _vm.voucher.currency_id
                                    )
                                  ) +
                                    _vm._s(
                                      _vm.utils.getCurrencyName(
                                        _vm.voucher.currency_id
                                      )
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "w-65 text-right",
                                staticStyle: { "word-break": "break-all" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.utils.getTaxRate(otherTax.tax_rate)
                                  )
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.target_flag")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _c("label", { staticClass: "checkbox-custom" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.voucher.target_flag,
                    expression: "voucher.target_flag"
                  }
                ],
                attrs: { type: "checkbox", disabled: "disabled", name: "" },
                domProps: {
                  checked: Array.isArray(_vm.voucher.target_flag)
                    ? _vm._i(_vm.voucher.target_flag, null) > -1
                    : _vm.voucher.target_flag
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.voucher.target_flag,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.voucher,
                            "target_flag",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.voucher,
                            "target_flag",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.voucher, "target_flag", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("span", { staticClass: "font30 fs-18" }, [
                _vm._v(_vm._s(_vm.$t("voucher.general.target")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.billed_flag")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _c("label", { staticClass: "checkbox-custom" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.voucher.billed_flag,
                    expression: "voucher.billed_flag"
                  }
                ],
                attrs: { type: "checkbox", disabled: "disabled", name: "" },
                domProps: {
                  checked: Array.isArray(_vm.voucher.billed_flag)
                    ? _vm._i(_vm.voucher.billed_flag, null) > -1
                    : _vm.voucher.billed_flag
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.voucher.billed_flag,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.voucher,
                            "billed_flag",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.voucher,
                            "billed_flag",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.voucher, "billed_flag", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("span", { staticClass: "font30 fs-18" }, [
                _vm._v(_vm._s(_vm.$t("voucher.general.target")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block-row" }, [
          _c("label", { staticClass: "row-lb font500" }, [
            _vm._v(_vm._s(_vm.$t("voucher.general.note")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row-cnt" }, [
            _vm._v(_vm._s(_vm.voucher.note))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showPdfViewer
        ? _c("pdf", { attrs: { voucher: _vm.voucher, closePdf: _vm.closePdf } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31167ba7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31167ba7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Voucher/Details/Temp_1.vue
// module id = null
// module chunks = 